import React, {useContext, useCallback} from 'react';
import styled from 'styled-components';
import NumericInput from './NumericInput';
import {FormBodyChangesContext} from './Bodies/FormBodyChangesWatcher';
import {isValidFunction} from '../../../util/utils';

function NumericInputChangeGuard({
	autoFocus,
	disabled,
	id,
	name,
	bodyId,
	label,
	maxLength,
	minLength,
	onAccept,
	onBlur,
	onCancel,
	onChange,
	onFocus,
	pattern,
	placeholder,
	progressBarClassName,
	progressBarLabel,
	required,
	showLabel,
	initialValue
}) {
	const {resetChanges, onBodyValueChanged} = useContext(FormBodyChangesContext);

	const onInputAccept = useCallback(
		(newValue) => {
			if (isValidFunction(onAccept)) {
				return onAccept(newValue).then(() => {
					resetChanges(bodyId, name);
				});
			} else {
				resetChanges(bodyId, name);
			}
		},
		[resetChanges, onBodyValueChanged]
	);

	const onInputChange = useCallback(
		(initialValue, newValue, name) => {
			if (isValidFunction(onChange)) {
				return onChange(newValue).then(() => {
					onBodyValueChanged(bodyId, initialValue, newValue, name);
				});
			} else {
				onBodyValueChanged(bodyId, initialValue, newValue, name);
			}
		},
		[onBodyValueChanged]
	);

	const onInputCancel = useCallback(
		(name) => {
			if (isValidFunction(onCancel)) {
				return onCancel().then(() => {
					resetChanges(bodyId, name);
				});
			} else {
				resetChanges(bodyId, name);
			}
		},
		[resetChanges]
	);

	return (
		<StyledNumericInputChangeGuard className="StyledNumericInputChangeGuard">
			<NumericInput
				autoFocus={autoFocus}
				disabled={disabled}
				id={id}
				name={name}
				label={label}
				maxLength={maxLength}
				onAccept={onInputAccept}
				onCancel={onInputCancel}
				onChange={onInputChange}
				onBlur={onBlur}
				onFocus={onFocus}
				maxLenght={maxLength}
				minLength={minLength}
				placeholder={placeholder}
				progressBarClassName={progressBarClassName}
				progressBarLabel={progressBarLabel}
				required={required}
				pattern={pattern}
				showLabel={showLabel}
				value={initialValue}
			/>
		</StyledNumericInputChangeGuard>
	);
}

export default NumericInputChangeGuard;

const StyledNumericInputChangeGuard = styled.section``;
